export default __webpack_public_path__ + "static/media/poki@3x.5975250f.png";